import React from 'react';
import Create from '../../../create';
import { useParams } from 'react-router-dom';
import DeliveryCharge from '../delivery_charge';

export default function BookParcel() {
  const schema = [
    {
      tabName: 'Company Details',
      editFields: [
        {
          label: 'Company Name',
          name: 'name',
          type: 'text',
        },
        {
          label: 'Phone Number',
          name: 'username',
          type: 'text',
        },
        {
          label: 'Email',
          name: 'email',
          type: 'text',
        },
        {
          label: 'Password',
          name: 'password',
          type: 'text',
        },
      ],
    },
  ];
  const { id }: any = useParams();

  return (
    <React.Fragment>
      <Create
        return="/dashboard/companies"
        url={`${process.env.REACT_APP_API_SERVER}/companies`}
        dataID={id}
        schema={schema}
      />
      <DeliveryCharge />
    </React.Fragment>
  );
}
